import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Registers the card database with the engine. Import it once, at startup.
import '@/data';
import '@/styles/tokens.css';
import '@/styles/base.css';
import { applyDocumentSettings, useSettings } from '@/app/stores';

// Apply the display settings before the first paint so a player with reduce
// motion on never sees a single animation.
applyDocumentSettings(useSettings.getState());

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
